import {
  GET_OFFER_INSTALLMENT_PLANS_REQUEST,
  GET_OFFER_INSTALLMENT_PLANS_SUCCESS,
  GET_OFFER_INSTALLMENT_PLANS_FAILURE,
} from '../actions/ActionGetOfferInstallmentPlans';

const initialState = {
  completed: false,
  error: false,
  sent: true,
  offer: false,
};
const installmentPlansReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_OFFER_INSTALLMENT_PLANS_REQUEST: {
      return {
        ...state,
        completed: false,
        error: false,
        sent: true,
      };
    }
    case GET_OFFER_INSTALLMENT_PLANS_SUCCESS: {
      return {
        ...state,
        completed: true,
        error: false,
        offer: action.resp.data.enabled_installment_plan,
      };
    }
    case GET_OFFER_INSTALLMENT_PLANS_FAILURE: {
      let msg = 'Tuvimos un error en nuestro sistema';

      return {
        ...state,
        completed: true,
        error: true,
        status_code: action.error.status,
        msg: msg,
      };
    }
    default:
      return state;
  }
};

export default installmentPlansReducer;
